<template>
  <c-typo
    v-bind="$attrs"
    class="info-hint"
    type="body-1"
    opacity="base-50"
  >
    <c-icon
      icon="info-information-circle"
      size="15"
    />

    <span>
      <slot />
    </span>
  </c-typo>
</template>

<script>
import CTypo from '../CTypo/index.vue'
import CIcon from '../CIcon/index.vue'

export default {
  name: 'CInfoHint',
  inheritAttrs: false,

  components: {
    CTypo,
    CIcon
  }
}
</script>

<style lang="scss">
.info-hint {
  display: flex;
  align-items: flex-start;

  & > .c-icon {
    margin-top: 2px;
    margin-right: 5px;
    flex-shrink: 0;
    stroke: color-var(text, base-50);
  }
}
</style>
